<template>
  <v-card>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div v-else>
      <v-card-title>
        Arqueo de Caja {{$moment(arqueo.fechaAlta).format('dddd DD [de] MMMM YYYY H:mm')}}
        <v-spacer></v-spacer>
        
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle
        >Efectuado por {{arqueo.usuario.nombre}}</v-card-subtitle
      >
      <v-card-text>
        <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    Valores en caja
                  </th>
                </tr>
              </thead>
            </template>
          </v-simple-table>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th v-for="(item, index) in arqueo.arqueo" :key="index">
                    {{ item.denominacion }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="(item, index) in arqueo.arqueo" :key="index">
                    {{item.cantidad}} ({{item.denominacion*item.cantidad}})
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    Total arqueo de caja
                  </th>
                  <th>
                    Diferencia con caja
                  </th>
                  <th>
                    Saldo
                  </th>
                  <th>
                    Cambio restante
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                      {{arqueo.total}}
                  </td>
                  <td>
                      {{arqueo.diferencia}}
                  </td>
                  <td>
                      {{arqueo.saldo}}
                  </td>
                  <td>
                      {{arqueo.cambio}}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  name: "Pedidos_Ver",
  data: () => ({
    loading: true,
    arqueo: null,
  }),
  computed: {
    _id() {
      return this.$route.params._id;
    },
  },
  methods: {
    async _obtenerArqueo() {
      this.loading = true;
      try {
        const arqueo = await axios.get("/arqueos/" + this._id);
        if(!arqueo) throw Error();
        this.arqueo = arqueo.data;
        this.loading = false;
      } catch (error) {
        this.$router.push("/arqueos");
      }
    },
    _cerrar() {
      this.$router.go(-1);
    },
  },
  created() {
    this._obtenerArqueo();
  },
};
</script>
